import { useEffect } from 'react'
import { useWorkspaceStore } from '@/store/workspaceStore'
import { pinnedThreadIdsFromThreads } from '@/services/chat/pinnedThreadIdsFromThreads'
import { fetchThreads, isThreadsApiAvailable } from '@/services/chat/threadsApi'
import { mergeBackendThreads } from './backendThreadMerge'

/** Load sidebar threads from `GET /v1/conversations` for the active workspace. */
export function useBackendThreadsList(setThreads, setPinnedThreadIds) {
  const workspaceId = useWorkspaceStore((s) => s.activeWorkspaceId)
  useEffect(() => {
    if (!isThreadsApiAvailable() || !workspaceId) {
      setThreads([])
      setPinnedThreadIds([])
      return undefined
    }
    const controller = new AbortController()
    fetchThreads({ signal: controller.signal, workspaceId })
      .then((threads) => {
        setThreads((prev) => mergeBackendThreads(prev, threads))
        setPinnedThreadIds(pinnedThreadIdsFromThreads(threads))
      })
      .catch(() => {})
    return () => controller.abort()
  }, [setThreads, setPinnedThreadIds, workspaceId])
}
